import React from 'react'
import { Grid, Typography, TextField, Button, Link} from '@mui/material'
import ButtonGroup from '../../../../../general/ButtonGroup'
import colors from '../../../../../colors'
import {setSearchValue, setSearchType, setCustomerName, selectVodafoneInvoicesState} from '../../../../../../features/vodafone/vodafoneInvoicesSlice'
import { useSelector, useDispatch } from 'react-redux';
import { sendGeneralRequest } from '../../../../../../features/generalRequest'
import { makeStyles } from '@mui/styles';
import { selectUserInfo } from '../../../../../../features/userInfo/userInfoSlice'
import { selectMyContractsState, setShouldFillFields } from '../../../../../../features/myContracts/myContractsSlice'
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { useNavigate } from 'react-router-dom'
import { texts } from '../../../../../general/texts'

export const VodafoneInvoices = (props) => {

    const searchMethods = [{display:texts["title-phone-number-short"], value: '1'}, {display:texts["title-client-code"], value: '2'}]

    const dispatch = useDispatch()
    const vodafoneInvoicesSliceState = useSelector(selectVodafoneInvoicesState) 
    const userInfo = useSelector(selectUserInfo)
    const myContractsSliceState = useSelector(selectMyContractsState)
    const navigate = useNavigate()
    
    const [state, setState] = React.useState({
        token: props.globalDataSliceState.token,
        customerName: '',
        searchValue: '',
        searchType: searchMethods[0].value
    })

    const handleTextFieldChange = (prop) => (e) => 
    {
        setState({
            ...state,
            [prop]: e.target.value
        })
    }

    const getSearchMethodValue = (value) => 
    {
        setState({
            ...state,
            searchType: value
        })
    }
    const handleButtonClick = () => 
    {
        dispatch(setSearchValue(state.searchValue))
        dispatch(setSearchType(state.searchType))
        dispatch(setCustomerName(state.customerName))
        dispatch(sendGeneralRequest({request: {...state, searchValue: state.searchValue.replace(/^0+/, '')}, baseUrlKey:'services', endpoint:'ASBS/GetVodafoneInvoices'}))
    }

    React.useEffect(()=>{
        if(myContractsSliceState.shouldFillFields)
        {
            setState({
                ...state,
                searchValue: props.selectedContractInfo.contract,
                customerName: props.selectedContractInfo.description
            })
            dispatch(setShouldFillFields(false))
        }
    },[myContractsSliceState.shouldFillFields])


    const selectedButtonStyle =
    {
        backgroundColor: colors.lightOrange,
        color: colors.orange,
        width:'150px',
        height:'40px',
        fontFamily:'GerberaBold',
        textTransform:'none',
        fontSize:'1rem',
        border: '2px solid'+colors.orange,
        borderRadius:'10px',
        '&:hover': {
            backgroundColor: colors.lightOrange
        },
        '@media (max-width: 899px)' : {width:'130px', height:'40px'}                 
    }

    const defaultButtonStyle =
    {
        backgroundColor: colors.lightBlue,
        width:'150px',
        height:'40px',
        borderRadius:'10px',
        textTransform:'none',
        fontFamily:'GerberaLight',
        fontSize:'1rem',
        color: colors.darkBlue,
        '&:hover': {
            backgroundColor: colors.lightOrange
        },
        '@media (max-width: 899px)' : {width:'130px', height:'40px'}      
    }


    const useStyles = makeStyles({
        mainGrid:{
            padding: '5%',
            paddingTop: '3%'
        },
        utilityName:{
            color:props.utilityInfo.Color,
            fontSize:'1.5rem',
            fontFamily:'GerberaBold',
            paddingTop:'3%',
            paddingLeft:'2%'
        },
        headerBox:{
            backgroundColor: colors.cyan,
            borderRadius:'100%',
            width:'70px',
            height:'70px'
        },
        fieldTitle:{
            color:colors.darkBlue,
            fontSize:'1.2rem',
            fontFamily:'GerberaBold',
            textAlign:'left'
        },
        button:{
            width:'100%',
            color:colors.white,
            background:colors.gradientOrange,
            fontFamily:'GerberaBold',
            textTransform:'none'
        },
        buttonGrid:{
            marginTop:5,
            paddingBottom: 2
        },
        image:{
            width:'70%'
        },
        textField:{
            width:'100%'
        }
    })
    
    const classes = useStyles()

  return (
    <Grid container item className={classes.mainGrid} rowSpacing={3} >
        <Grid container item md={2} xs={2} mt={2} ><Link component={'button'} onClick={()=> { navigate(-1)}}><ArrowBackIosNewIcon color='warning' /></Link></Grid>    
        <Grid container item md={12} xs={12} >
        <Grid container direction="row" justifyContent="center" alignItems="center" className={classes.headerBox} ><img src={props.utilityInfo.Images.filter(image => image.color === 1 && image.size === 1)[0].imagePath} className={classes.image}/></Grid>
            <Typography className={classes.utilityName} >{props.utilityInfo.PublicName}</Typography>
        </Grid>
        <Grid container item md={12} xs={12}><Typography sx={{textAlign:'left', fontSize:'0.9rem', fontFamily:'GerberaLight', color:colors.darkBlue}} >{props.utilityInfo.Information}</Typography></Grid>                                                 
        <Grid container item md={12} xs={12}>
            <Typography className={classes.fieldTitle}>{texts["prompt-choose-search-method"]}</Typography>
        </Grid>                            
        <Grid container item md={12} xs={12} justifyContent='flex-start' columnSpacing={5} rowSpacing={3}>
            <ButtonGroup defaultButtonStyle={defaultButtonStyle} selectedButtonStyle={selectedButtonStyle} state={searchMethods} sendValue={getSearchMethodValue}/> 
        </Grid>                                                                                                
        {state.searchType === '1' &&
            <Grid container item rowSpacing={3} >
                <Grid item md={12} xs={12} >
                    <Typography className={classes.fieldTitle}>{texts["title-phone-number-short"]}</Typography>
                </Grid>
                <Grid item md={12} xs={12} >
                    <TextField onChange={handleTextFieldChange('searchValue')} value={state.searchValue} color='warning' size='small' label={texts["placeholder-phone-number"]} className={classes.textField} />
                </Grid>
            </Grid>
        }
        {state.searchType === '2' &&
            <Grid container item rowSpacing={3} >
                <Grid item md={12} xs={12} >
                    <Typography className={classes.fieldTitle}>{texts["title-client-code"]}</Typography>
                </Grid>
                <Grid item md={12} xs={12} >
                    <TextField onChange={handleTextFieldChange('searchValue')} color='warning' size='small' label={texts["dialog-client-code"]} className={classes.textField} />
                </Grid>
            </Grid>
        }
        <Grid container item md={12} xs={12} justifyContent='flex-start'>
            <TextField onChange={handleTextFieldChange('customerName')} value={state.customerName} color='warning' size='small' label={texts["placeholder-customer-name"]} className={classes.textField} />
        </Grid> 
        <Grid item md={12} xs={12} className={classes.buttonGrid} >
            <Button disabled={(vodafoneInvoicesSliceState.isLoading ? true : false) || (!state.searchValue || !state.customerName)} onClick={handleButtonClick} className={classes.button}>{texts["title-pay"]}</Button>
        </Grid>                                                       
    </Grid>
  )
}
export default VodafoneInvoices